<template>
  <v-container>
    <v-row class="title text-h4 text-uppercase">
      {{ $t('title') }}
    </v-row>
    <v-card
      :loading="login_load"
      class="mx-auto my-12"
      max-width="374"
    >
      <template slot="progress">
        <v-progress-linear
          height="10"
          indeterminate
        />
      </template>

      <v-card-title class="title font-weight-bold text-uppercase">
        {{ $t('common.login') }}
      </v-card-title>

      <v-card-text>
        <v-row
          align="center"
          class="mx-0 my-2"
        >
          <v-text-field
            id="inputUsername"
            v-model="authInfo.username"
            :label="$t('username')"
            prepend-icon="fa-user-tie"
            :error="error.length ? (error.username.length && true) : false"
            :error-messages="error.username"
            @keyup.enter="$refs.inputPassword.focus()"
          />
        </v-row>

        <v-row
          align="center"
          class="mx-0 my-2"
        >
          <v-text-field
            id="inputPassword"
            ref="inputPassword"
            v-model="authInfo.password"
            :label="$t('password')"
            prepend-icon="fa-key"
            :error="error.length ? (error.password.length && true) : false"
            :error-messages="error.password"
            type="password"
            @keyup.enter="login()"
          />
        </v-row>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          large
          text
          @click="login"
        >
          {{ $t('common.login') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<i18n src="@/components/functions/Auth/locales/en.json"></i18n>
<i18n src="@/components/functions/Auth/locales/zhHant.json"></i18n>

<script>
import ErrorDisplay from '@/components/functions/Common/mixins/ErrorDisplay'
import SysUtils from '@/base/utils/SysUtils'

export default {
  name: 'PgLogin',
  mixins: [ErrorDisplay],
  data: function () {
    return {
      authInfo: {
        username: '',
        password: ''
      },
      login_load: false,
      error: {}
    }
  },
  computed: {
    validations () {
      return this.$store.state.Auth.validations
    },
    validationLocale () {
      return this.validations.messages[this.currentLocale]
    }
  },
  mounted () {
    this.$emit('pageName', this.$t('common.login'))
    this.$store.dispatch('Auth/getAdminLoginValidations')
      .catch((err) => {
        this.showError(err)
      })
  },
  methods: {
    login () {
      this.login_load = true
      const auth = {
        username: this.authInfo.username,
        password: this.authInfo.password
      }
      this.error = {}
      SysUtils.validate(auth, this.validations)
        .then(validated => {
          if (validated.valid) {
            return this.$store.dispatch('Auth/login', auth)
              .then((user) => {
                if (user) {
                  this.changeLocale(user.language)
                  this.$router.push({ name: 'Top' })
                }
              })
              .catch((err) => {
                this.showError(err, true)
                this.login_load = false
              })
          } else {
            this.error = validated.results
          }
          this.login_load = false
        })
    }
  }
}
</script>

<style scoped>
.title {
  margin: 30px;
  justify-content: center;
}
</style>
